export class MensagemPersonalizada {
  variaveis = [];
  dataEnvio = new Date();

  constructor(body) {
    this.contexto = body.contexto;
    this.mensagem = body.mensagem;
    this.ativado = body.ativado;
    this.tipo = body.tipo;
    
    let anexo = body.anexo;
    if (body.anexo) {
      const names = body.anexo.split("/"), size = names.length;
      anexo = names[size - 1];
    }
    this.anexo = anexo;
    this.horaEnvio = body.horaEnvio;
    this.diasAntecedencia = body.diasAntecedencia;
  }

  setHandleChangeInput(name, value) {
    this[name] = value;
  }

  setVariaveis(variaveis) {
    this.variaveis = variaveis;
  }

  setListaPessoaIds(arrayIdPessoa) {
    this.pessoaIds = arrayIdPessoa;
  }

  setContextoStatus(status) {
    const contextoStatus = `${this.contexto}-${status.toLowerCase()}`;
    this.contexto = contextoStatus;
  }

  setAnexo(anexo) {
    this.anexo = anexo;
  }
}